import {
  REQUEST_FETCH_ENTITY_AD,
  FETCH_ENTITY_AD_SUCCESS,
  FETCH_ENTITY_AD_FAILURE,
  CLEAR_FETCH_ENTITY_AD_STATES,
} from "./entity.types";

let initialState = {
  reload: false,
  response: {},
  error: null,
  loading: false,
};

const entityAdReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_FETCH_ENTITY_AD:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ENTITY_AD_SUCCESS:
      return {
        ...state,
        loading: false,
        response: action.payload,
        reload: false,
      };

    case FETCH_ENTITY_AD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        reload: false,
      };

    case CLEAR_FETCH_ENTITY_AD_STATES:
      return {
        ...state,
        loading: false,
        response: {},
        error: null,
        reload: false,
      };

    default:
      return state;
  }
};

export default entityAdReducer;
